import { useAuth } from '@clerk/clerk-react';
import { Navigate, Outlet } from 'react-router-dom';
import { Spinner } from '../../shared/ui/Spinner';
import { useAppStore } from '../../store/useAppStore';

const ROLE_HOME: Record<string, string> = {
  admin: '/staff-portal',
  driver: '/staff-portal',
  customer: '/app/requests',
};

export function RedirectIfSignedIn() {
  const { isLoaded, isSignedIn } = useAuth();
  const user = useAppStore((s) => s.user);

  if (!isLoaded) {
    return (
      <div className="flex h-screen items-center justify-center bg-[#0a0a0a]">
        <Spinner size="lg" />
      </div>
    );
  }

  if (isSignedIn) {
    if (user === null) {
      return (
        <div className="flex h-screen items-center justify-center bg-[#0a0a0a]">
          <Spinner size="lg" />
        </div>
      );
    }
    return <Navigate to={ROLE_HOME[user.role] ?? '/app/requests'} replace />;
  }

  return <Outlet />;
}
